import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function ExteriorPrefabSection() {
  const { t } = useTranslation('common');
  
  const stats = [
    { number: '60%', label: 'Daha Hızlı İnşaat' },
    { number: '40%', label: 'Maliyet Tasarrufu' },
    { number: '100%', label: t('hero.customDesign') }
  ];

  return (
    <section id="dis-cephe" className="py-0 bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Left - Image */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative h-[600px] lg:h-auto"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/e22594317adb3f3b3c37306061c0dea0.jpg"
            alt="Prefabrik Yapı"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/40"></div>
        </motion.div>

        {/* Right - Content */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex items-center justify-center bg-white px-8 lg:px-20 py-20"
        >
          <div className="max-w-xl">
            <div className="inline-block border border-gray-300 text-gray-700 px-4 py-2 rounded-full text-xs font-light tracking-wider mb-8 whitespace-nowrap">
              {t('exterior.prefabTitle')}
            </div>

            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              <div>{t('exterior.title')}</div>
              <div>{t('exterior.prefabSubtitle')}</div>
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed mb-12" style={{ lineHeight: '1.8' }}>
              {t('exterior.prefabDescription')}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-12">
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.4 + index * 0.1 }}
                  className="bg-gray-50 rounded-2xl p-6 text-center"
                >
                  <div className="text-4xl font-bold text-gray-900 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-xs text-gray-600 leading-tight">
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </div>

            <a
              href="#prefabrik"
              className="inline-block border-2 border-gray-900 text-gray-900 px-10 py-4 rounded-full text-sm font-light tracking-wide hover:bg-gray-900 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('exterior.learnMore')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
